import React, { PureComponent } from 'react';
import ICONS from '../ICONS';
import TOOLTIP from '../TOOLTIP';
import './TASKBAR.css';
import BUTTON from '../BUTTON';
import SYSTRAY from './SYSTRAY';
import MENU from '../menus/MENU.js';

function buildPrograms(path, launcher) {

    var items = [];
    let dirContents = window.WINAPI.FindFile(path);
    for (var i = 0; i < dirContents.length; i += 1) {
        let item = dirContents[i];
        let launchPath = path + "\\" + item.name;

        if (item.type == "directory") {

            items.push({
                "type": "menu",
                "style": 'start-menu-programs',
                "icon": ICONS.PROGMENU,
                "text": item.displayName || item.name,
                "items": buildPrograms(launchPath, launcher)
            });
        } else {

            items.push({
                "type": "item",
                "icon": item.icon16,
                "text": item.displayName || item.name,
                "onclick": () => launcher(launchPath)
            });
        }
    }

    items.sort((a, b) => {
        if (a.type == "menu" && b.type != "menu") {
            return -1;
        }
        if (a.type != "menu" && b.type == "menu") {
            return 1;
        }

        return a["text"].localeCompare(b["text"]);
    });

    return items;
}

class TASKBAR extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { startOpen: false };

        // saved for later
        var startMenuContents = {
            style: 'start-menu',
            items: [
                { text: "Undo", accel: "U", shortcut: "Ctrl+Z", disabled: true },
                { type: "divider" },
                { text: "Cut", accel: "t", shortcut: "Ctrl+X", disabled: true },
                { text: "Copy", accel: "C", shortcut: "Ctrl+C", disabled: true },
                { text: "Paste", accel: "P", shortcut: "Ctrl+V", disabled: true },
                { text: "Paste Shortcut", accel: "S", disabled: true },
                { type: "divider" },
                { text: "Select All", accel: "A", shortcut: "Ctrl+A" },
                { text: "Invert Selection", accel: "I" }
            ]
        };
    }

    componentWillMount() {
        this.globalDismissHandler = window.WINAPI.SetWinEventHook('dismiss', () => {
            if (this.state.startOpen == true) {
                this.setState({ startOpen: false });
            }
        });
    }

    componentWillUnmount() {
        window.WINAPI.UnhookWinEvent('dismiss', this.globalDismissHandler);
    }

    render() {
        // Create list of open windows based on non-menu WNDs
        var windows = [];
        this.props.hwnds.forEach((hwnd) => {
            var wnd = window.WINAPI.FindWindow(hwnd);
            if (wnd.appearOnTaskbar()) {
                let icon = wnd.icon();
                var title = wnd.title();

                let inner = <div className="app-btn-inner">
                    {icon ? <img src={icon} /> : null}
                    <div>{title}</div>
                </div>;
                
                windows.push(<BUTTON tooltip={title} key={hwnd}
                    onPress={(e) => window.WINAPI.SetActiveWindow(hwnd)}
                    selected={hwnd == this.props.foregroundHwnd}>
                    {inner}
                </BUTTON>);
            }
        });

        // Create start menu (if open)
        var startMenu = null;
        if (this.state.startOpen) {
            let programs = buildPrograms("C:\\WINDOWS\\Start Menu\\Programs", (p) => window.WINAPI.CreateProcess(p));
            let documents = buildPrograms("C:\\WINDOWS\\Start Menu\\Documents", (p) => window.WINAPI.ShellExecute(p));
            var startMenuContents = {
                style: 'start-menu',
                items: [
                    { type: "menu", style: 'start-menu-programs', icon: ICONS.PROGRAMS, text: "Programs", accel: "P", items: programs },
                    { type: "menu", style: 'start-menu-programs', icon: ICONS.DOCS, text: "Documents", accel: "D", items: documents },
                    { icon: ICONS.SETTINGS, text: "Settings", accel: "S", onclick: () => window.WINAPI.SysCrashDump(1) },
                    { icon: ICONS.FIND, text: "Find", accel: "F", onclick: () => window.WINAPI.SysCrashDump(1) },
                    { icon: ICONS.HELP, text: "Help", accel: "H", onclick: () => window.WINAPI.SysCrashDump(1) },
                    { icon: ICONS.RUN, text: "Run...", accel: "R", onclick: () => window.WINAPI.SysCrashDump(2) },
                    { type: "divider" },
                    { icon: ICONS.SHUTDOWN, text: "Shut Down...", accel: "u", onclick: () => window.WINAPI.InitiateShutdown() }
                ]
            };

            startMenu = <MENU menu={startMenuContents} direction="up" bottom={24} left={2} onDismiss={() => {
                this.setState({ "startOpen" : false });
            }} />;
        }

        // Render complete bar
        return (
            <div className="win-taskbar" onClick={() => window.WINAPI.SetActiveWindow(-1)}>
                <BUTTON tooltip={this.state.startOpen ? undefined : "Click here to begin"} onDown={() => { this.toggleStartMenu(); }} selected={this.state.startOpen}>
                    <img src={ICONS.START} alt="Start" />
                </BUTTON>
                <div className="win-taskbar-apps">
                    {windows}
                </div>
                <SYSTRAY />
                {startMenu}
            </div>
        );
    }

    toggleStartMenu() {
        this.setState({ startOpen: !this.state.startOpen });
    }
}

export default TASKBAR;



// WEBPACK FOOTER //
// ./src/walleris/EXPLORE/TASKBAR.js